var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('div',{staticClass:"modal_block"},[_c('div',{staticClass:"modal_inner"},[_c('div',{staticClass:"modal_content"},[(_vm.showClose)?_c('span',{staticClass:"modal_close icon_close",on:{"click":_vm.closePopup}}):_vm._e(),_vm._t("default")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }